<template>
	<v-card class="skill"
		width="300px"
		min-height="135px"
		:color="color"
		dark
	>
		<div class="d-flex flex-no-wrap justify-space-between">
			<div class="d-flex flex-wrap">
				<v-card-title class="headline w-100">
					{{ language }}
				</v-card-title>
				<v-card-subtitle class="body-1 pa-0 pl-5 w-100"
					v-for="(framework, key) in subskills"
					:key="key"
				>
					<span v-show="key < 2 || chevron"	>
						- {{ framework }}
					</span>
				</v-card-subtitle>
				
				<v-card-text class="body-2 pa-0 pl-5 fav"
					v-if="fav"
					v-show="subskills.length < 2 || chevron"
				>
					Favorability : {{ fav }}
				</v-card-text>
				<v-card-text class="body-2 pa-0 pl-4"
				>
					<p class="period"
						v-if="period"
						v-show="chevron"
					>
						経験年数 : {{ period }}年
					</p>
					<p class="comment"
						v-if="comment"
						v-show="chevron"
					>
						{{ comment }}
					</p>
				</v-card-text>

				<v-card-actions class="pt-0 pb-0 minh-40">
					<v-btn rounded
						v-if="0 < plus"
						@click="chevron = !chevron"
					>
					<v-icon>
						{{ chevron ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
					</v-icon>
					{{ plus }}
					</v-btn>
				</v-card-actions>
			</div>

			<v-avatar
				class="ma-3"
				size="100"
				tile
			>
				<v-icon 
					v-if="icon.startsWith('mdi')"
					size="90"
				>{{ icon }}
				</v-icon>
				<v-img
					v-else
					:src="icon"
					contain
					width="90"
					height="90">
				</v-img>
			</v-avatar>
		</div>
	</v-card>
</template>

<style>
.w-100 {
  width: 100%;
}
.minh-40{
  min-height: 40px;
}
</style>

<script>

export default {
  props: {
    language: {
      type: String,
      required: true
    },
    subskills: {
      type: Array,
      required: true
    },
    icon: {
      type: String,
      required: true
		},
		fav: {
			type: String,
			required: false
		},
    period: {
			type: Number,
      required: false
    },
		comment: {
			type: String,
			required: false
		},
    color: {
      type: String,
      default: 'grey darken-4',
      required: false
    }
  },
  data: function () {
		return {
			chevron: false
		}
	},
	computed: {
		plus: function () {
			// 非表示になっている件数をカウントする
			var plus = this.subskills.length > 2 ? this.subskills.length - 2 : 0
			plus = this.fav && this.subskills.length > 1 ? plus + 1 : plus
			plus = this.period ? plus + 1 : plus
			plus = this.comment ? plus + 1 : plus
			return plus
		}
	}
}

</script>